import { render, staticRenderFns } from "./ImageUploadMultiple.vue?vue&type=template&id=10578cb7"
import script from "./ImageUploadMultiple.vue?vue&type=script&lang=js"
export * from "./ImageUploadMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports